import { PropsWithChildren } from 'react';

import { Link } from '@xing-com/link';

type Props = {
  link?: string;
};

export const CompanyLink: React.FC<PropsWithChildren<Props>> = ({
  link,
  children,
  ...linkProps
}) => {
  if (!link) {
    return <>{children}</>;
  }

  return (
    <Link to={link} {...linkProps}>
      {children}
    </Link>
  );
};
